function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-24x24-\\u0421alculation",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18,0 C19.6568542,0 21,1.34314575 21,3 L21,3 L21,21 C21,22.6568542 19.6568542,24 18,24 L18,24 L6,24 C4.34314575,24 3,22.6568542 3,21 L3,21 L3,3 C3,1.34314575 4.34314575,0 6,0 L6,0 Z M18,2 L6,2 C5.44771525,2 5,2.44771525 5,3 L5,3 L5,21 C5,21.5522847 5.44771525,22 6,22 L6,22 L18,22 C18.5522847,22 19,21.5522847 19,21 L19,21 L19,3 C19,2.44771525 18.5522847,2 18,2 L18,2 Z M13,17 L13,19 L11,19 L11,17 L13,17 Z M9,17 L9,19 L7,19 L7,17 L9,17 Z M17,17 L17,19 L15,19 L15,17 L17,17 Z M13,13 L13,15 L11,15 L11,13 L13,13 Z M9,13 L9,15 L7,15 L7,13 L9,13 Z M17,13 L17,15 L15,15 L15,13 L17,13 Z M16,5 C16.5522847,5 17,5.44771525 17,6 L17,9 C17,9.55228475 16.5522847,10 16,10 L8,10 C7.44771525,10 7,9.55228475 7,9 L7,6 C7,5.44771525 7.44771525,5 8,5 L16,5 Z",
  id: "Combined-Shape",
  fill: "#60CAA8",
  fillRule: "nonzero"
}));

var SvgCalculations = function SvgCalculations(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculations, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calculations.35d42800.svg";
export { ForwardRef as ReactComponent };